<template>
  <div class="description">
    <div
      v-if="soldCount > 1000 && [2, 5, 8].includes(soldCount % 10)"
      class="bestseller"
    >
      Bestseller
    </div>
    <div class="description-top">
      <div class="content">
        <div
          :class="{ 'expanded': showAllText }"
          class="content-l"
        >
          {{ detailInfo?.subjectTrans }}
          <Icon
            v-if="!showAllText"
            @click="showAllText = true"
            class="show-more"
            name="arrow-down-l-2"
          />
          <span
            v-else
            class="report"
          >
            <Tooltip
              :offset="6"
              trigger="click"
              placement="left"
            >
              <template #content>
                <div style="width: 150px;">There are user reports, please choose carefully.</div>
              </template>
              <span
                v-if="detailInfo?.report"
                class="report-icon"
              >
                <Icon name="icon-warning-outline" />
              </span>
            </Tooltip>
            <span
              v-if="!detailInfo?.report"
              @click="openReportDialog"
            >Report</span>
          </span>
        </div>
        <div
          v-if="!showAllText"
          class="report"
        >
          <Tooltip
            :offset="6"
            trigger="click"
            placement="left"
          >
            <template #content>
              <div style="width: 150px;">
                There are user reports, please choose carefully.
              </div>
            </template>
            <span
              v-if="detailInfo?.report"
              class="report-icon"
            >
              <Icon name="icon-warning-outline" />
            </span>
          </Tooltip>
          <span
            v-if="!detailInfo?.report"
            @click="openReportDialog"
          >Report</span>
        </div>
      </div>
    </div>
    <div
      class="best-supplier"
      v-if="factory?.honestMerchant && factory.honestMerchant >= 5"
    >
      <img
        src="@/assets/colorIcon/best-supplier.svg"
        alt=""
      >
      <span class="dot">·</span>
      <img
        class="img2"
        src="@/assets/colorIcon/best-manufacturer.svg"
        alt=""
      >
      <span class="dot">·</span>
      <span class="years">{{ factory.honestMerchant }} years</span>
    </div>
    <div
      v-if="detailInfo?.sellerDataInfo"
      class="product-rating"
    >
      <template v-if="Number(detailInfo.sellerDataInfo.compositeServiceScore) > 0">
        <div class="star-rating">
          <StarRate :value="detailInfo.sellerDataInfo.compositeServiceScore" />
          <div class="rating-num">
            {{ Number(detailInfo.sellerDataInfo.compositeServiceScore).toFixed(1) }}
          </div>
        </div>
      </template>
      <template v-if="soldCount > 0">
        <div
          v-if="Number(detailInfo.sellerDataInfo.compositeServiceScore) > 0"
          class="separator"
        />
        <div class="sold-count">
          <span>{{ formatSalesVolume(soldCount) }}</span> sold
          <!-- <Icon name="icon-help-tip-l" /> -->
        </div>
      </template>
      <template v-if="showAdding">
        <div class="separator" />
        <div class="adding-cart">
          {{ addingCount }} adding to cart
        </div>
      </template>
      <template v-if="!showAdding && Number(detailInfo.sellerDataInfo.repeatPurchasePercent) > 0">
        <div class="separator" />
        <div class="custom-rate">
          Customer reorder rate <span>{{ (detailInfo.sellerDataInfo.repeatPurchasePercent * 100).toFixed(0) }}</span>%
        </div>
      </template>
    </div>

    <Popup
      v-model:show="reportDialogVisible"
      teleport="body"
      position="bottom"
      height="100%"
    >
      <Report
        @close="reportDialogVisible = false"
        :target-id="detailInfo.offerId"
      />
    </Popup>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { buriedPointUtil, formatSalesVolume } from '@/utils/utils'
import Icon from '@/components/Icon/Icon.vue'
import { StarRate } from '@/components/StarRate'
import { Popup } from '@/components/Popup'
import Report from './Report.vue'
import { Tooltip } from '@/components/Tooltip'
import { useFactory } from '@/components/SupplierHeader/useFactory'

const props = defineProps({
  detailInfo: {
    type: Object,
    default: () => ({})
  }
})

const { factory } = useFactory(computed(() => props.detailInfo?.sellerOpenId))

const route = useRoute()

const showAllText = ref(false)

const reportDialogVisible = ref(false)

const soldCount = computed(() => {
  if (route.query.key) {
    const queryCount = atob(route.query.key)
    if (props.detailInfo?.soldOut > queryCount) {
      return props.detailInfo?.soldOut
    }
    return queryCount
  } else {
    return props.detailInfo?.soldOut
  }
})

const showAdding = computed(() => {
  return route.query.adding &&
    soldCount.value > 300 &&
    props.detailInfo.sellerDataInfo.repeatPurchasePercent > 0.6 &&
    [2, 3, 6, 7].includes(soldCount.value % 10)
})

const addingCount = computed(() => {
  return atob(route.query.adding)
})

const openReportDialog = () => {
  buriedPointUtil({
    eventId: 'HPD206',
    others: {
      type: 'Products',
      objectId: props.detailInfo?.offerId
    }
  })
  reportDialogVisible.value = true
}
</script>

<style lang='less' scoped>
.description {
  padding: 0 12px;
  margin-top: 16px;
  .bestseller {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 68px;
    height: 18px;
    border-radius: 2px;
    color: #1B3E9C;
    font-size: 11px;
    font-family: mon-700;
    background-color: #D3E1FD;
  }
  .description-top {
    display: flex;
    margin-bottom: 8px;
    margin-top: 4px;
    .content {
      display: flex;
      align-items: end;
    }
    .content-l {
      position: relative;
      font-family: mon-600;
      font-size: 14px;
      line-height: 18px;
      color: #232323;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      padding-right: 12px;

      &.expanded {
        -webkit-line-clamp: unset;
        display: block;
      }

      .show-more {
        position: absolute;
        bottom: 2px;
        right: 0;
      }
    }

    .report {
      position: relative;
      color: #5c5c5c;
      font-size: 11px;
      font-family: mon-500;
      text-decoration: underline;
      cursor: pointer;
      margin-left: 10px;
      line-height: 18px;
      &:hover {
        color: var(--link-hover-color);
      }

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: -6px;
        transform: translateY(-50%);
        height: 10px;
        width: 1px;
        background-color: #dfdfdf;
      }

      .report-icon {
        color: #DB7E25;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  .best-supplier {
    display: flex;
    align-items: center;
    height: 18px;
    margin-bottom: 6px;
    .img2 {
      position: relative;
      top: -2px;
    }
    .dot {
      color: #B2B7C2;
      margin: 0 4px;
    }
    .years {
      color: #232323;
      font-size: 11px;
      font-family: mon-500;
    }
  }
  .product-rating {
    display: flex;
    align-items: center;
    height: 14px;

    .star-rating {
      display: flex;
      align-items: center;
      gap: 2px;
      ::v-deep(.rate-item) {
        font-size: 15px;
      }
      .rating-num {
        font-size: 11px;
        font-family: mon-600;
        color: #232323;
      }
    }
    .sold-count {
      color: #232323;
      font-size: 11px;
      font-family: mon-500;
      span {
        font-family: mon-600;
      }
    }
    .adding-cart {
      color: #1153D6;
      font-size: 11px;
      font-family: mon-500;
    }
    .custom-rate {
      color: #232323;
      font-size: 11px;
      font-family: mon-500;
      span {
        font-family: mon-600;
      }
    }
    .separator {
      height: 8px;
      width: 1px;
      background-color: #dfdfdf;
      margin: 0 8px;
    }
  }
}
</style>
